export enum AmountVariant {
  FULL = "full",
  PER_SQUARE = "per_square",
  PER_MONTH = "per_month",
  EMPTY = "empty",
  TABLE = "table",
  SMALL = "small",
}
